// extracted by mini-css-extract-plugin
export default {"testimonial":"Testimonials_testimonial__RpeGc","quote":"Testimonials_quote__zkSXX","author":"Testimonials_author__Ot5Xe","role":"Testimonials_role__UVZMo"};